module.exports = __webpack_public_path__ + "static/unf.40825eb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/highered_logos/unf.png
// module id = 2206
// module chunks = 61762850755587